import { render, staticRenderFns } from "./AlertaSnackBar.vue?vue&type=template&id=38939e44&scoped=true"
import script from "./AlertaSnackBar.vue?vue&type=script&lang=js"
export * from "./AlertaSnackBar.vue?vue&type=script&lang=js"
import style0 from "./AlertaSnackBar.vue?vue&type=style&index=0&id=38939e44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38939e44",
  null
  
)

export default component.exports